export default {
  methods: {
    // 返回
    backHandle () {
      this.$router.push({
        name: 'apply-select'
      })
    }
  }
}
